import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/showSmnCaPpageCarousel/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showSmnCaPpageCarouselSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showSmnCaPpageCarouselSelector };
